import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	OfflineCacheDeleteContentRequest,
	OfflineCacheDeleteContentResult,
	OfflineCacheDeleteFileRequest,
	OfflineCacheDeleteFileResult,
	OfflineCacheFileLoaded,
	OfflineCacheFilesListed,
	OfflineCacheGetChecksumRequest,
	OfflineCacheGetChecksumResult,
	OfflineCacheListContentRequest,
	OfflineCacheListContentResult,
	OfflineCacheListFiles,
	OfflineCacheLoadContentRequest,
	OfflineCacheLoadContentResult,
	OfflineCacheLoadFile,
	OfflineCacheLoadOrSaveFileRequest,
	OfflineCacheLoadOrSaveFileResult,
	OfflineCacheRequests,
	OfflineCacheSaveContentRequest,
	OfflineCacheSaveContentResult,
	OfflineCacheValidateChecksumRequest,
	OfflineCacheValidateChecksumResult,
} from './offlineCacheCommands';

export function handleOfflineCacheRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<OfflineCacheRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<OfflineCacheRequests>) => {
		switch (commandEvent.command.type) {
			case OfflineCacheListFiles:
				await dispatch<OfflineCacheFilesListed>({
					type: OfflineCacheFilesListed,
					fileUids: await frontApplet.offline.cache.listFiles(),
				});
				break;
			case OfflineCacheLoadFile:
				await dispatch<OfflineCacheFileLoaded>({
					type: OfflineCacheFileLoaded,
					file: await frontApplet.offline.cache.loadFile(commandEvent.command.uid),
				});
				break;
			case OfflineCacheGetChecksumRequest:
				await dispatch<OfflineCacheGetChecksumResult>({
					type: OfflineCacheGetChecksumResult,
					result: await frontApplet.offline.cache.getChecksumFile(commandEvent.command.uid, commandEvent.command.hashType),
				});
				break;
			case OfflineCacheValidateChecksumRequest:
				await dispatch<OfflineCacheValidateChecksumResult>({
					type: OfflineCacheValidateChecksumResult,
					result: await frontApplet.offline.cache.validateChecksumFile(
						commandEvent.command.uid,
						commandEvent.command.hash,
						commandEvent.command.hashType,
					),
				});
				break;
			case OfflineCacheLoadOrSaveFileRequest:
				await dispatch<OfflineCacheLoadOrSaveFileResult>({
					type: OfflineCacheLoadOrSaveFileResult,
					file: await frontApplet.offline.cache.loadOrSaveFile(
						commandEvent.command.uid,
						commandEvent.command.uri,
						commandEvent.command.headers,
					),
				});
				break;
			case OfflineCacheDeleteFileRequest:
				await frontApplet.offline.cache.deleteFile(commandEvent.command.uid);
				await dispatch<OfflineCacheDeleteFileResult>({
					type: OfflineCacheDeleteFileResult,
					result: {},
				});
				break;
			case OfflineCacheListContentRequest:
				await dispatch<OfflineCacheListContentResult>({
					type: OfflineCacheListContentResult,
					result: await frontApplet.offline.cache.listContents(),
				});
				break;
			case OfflineCacheLoadContentRequest:
				await dispatch<OfflineCacheLoadContentResult>({
					type: OfflineCacheLoadContentResult,
					result: await frontApplet.offline.cache.loadContent(commandEvent.command.uid),
				});
				break;
			case OfflineCacheSaveContentRequest:
				await frontApplet.offline.cache.saveContent(commandEvent.command.uid, commandEvent.command.content);
				await dispatch<OfflineCacheSaveContentResult>({
					type: OfflineCacheSaveContentResult,
					result: {},
				});
				break;
			case OfflineCacheDeleteContentRequest:
				await frontApplet.offline.cache.deleteContent(commandEvent.command.uid);
				await dispatch<OfflineCacheDeleteContentResult>({
					type: OfflineCacheDeleteContentResult,
					result: {},
				});
				break;
			default:
		}
	});
}
